import fetchExpresso from 'utility/fetchExpresso';

import type { ReportView, ReportViewVisibility } from './reportViewTypes';

export async function shareReportView(
    eventId: number,
    viewId: number,
    visibility: ReportViewVisibility,
): Promise<ReportView> {
    const res = await fetchExpresso(`/apiv2/events/${eventId}/report-views/${viewId}/share`, {
        method: 'PATCH',
        body: { visibility },
    });

    if (!res.ok) {
        const error = (await res.json().catch(() => null)) as { message?: string } | null;
        throw new Error(error?.message || 'Failed to share report view');
    }

    const data = (await res.json()) as { view: ReportView };
    return data.view;
}
